import i18next from "i18next";
import {initReactI18next} from "react-i18next";
import common_en from "./en/common.json";
import order_en from "./en/order.json";
import order_da from "./da/order.json";
import common_da from "./da/common.json";
import log_en from "./en/log.json";
import log_da from "./da/log.json";
import auth_da from "./da/auth.json";
import auth_en from "./en/auth.json";
import product_en from "./en/product.json";
import product_da from "./da/product.json";
import customer_en from "./en/customer.json";
import customer_da from "./da/customer.json";
import business_en from "./en/business.json";
import business_da from "./da/business.json";
import economic_en from "./en/economic.json";
import economic_da from "./da/economic.json";
import stripe_en from "./en/stripe.json";
import stripe_da from "./da/stripe.json";
import mobilepay_en from "./en/mobilepay.json";
import mobilepay_da from "./da/mobilepay.json";
import product_setting_en from "./en/product_setting.json";
import product_setting_da from "./da/product_setting.json";
import schedule_en from "./en/schedule.json";
import schedule_da from "./da/schedule.json";
import help_en from "./en/help.json";
import help_da from "./da/help.json";

i18next
    .use(initReactI18next)
    .init({
        debug: true,
        resources: {
            en: {
                translation: {
                    common: common_en,
                    order: order_en,
                    auth: auth_en,
                    product: product_en,
                    customer: customer_en,
                    business: business_en,
                    economic: economic_en,
                    stripe: stripe_en,
                    mobilepay: mobilepay_en,
                    log: log_en,
                    product_setting: product_setting_en,
                    schedule: schedule_en,
                    help: help_en,

                }
            },
            da: {
                translation: {
                    common: common_da,
                    auth: auth_da,
                    order: order_da,
                    product: product_da,
                    customer: customer_da,
                    business: business_da,
                    economic: economic_da,
                    stripe: stripe_da,
                    mobilepay: mobilepay_da,
                    log: log_da,
                    product_setting: product_setting_da,
                    schedule: schedule_da,
                    help: help_da,
                }
            },
        },
        lng: 'en',
        fallbackLng: 'en',
        supportedLngs: ['en', 'da'],

        interpolation: {
            escapeValue: false,
        },
    });
